import React, { useEffect, useState, forwardRef } from 'react';
import { styles } from '../styles/stylesFormStatus';

const steps = [
  { key: 'sending', label: 'Enviando' },
  { key: 'saved', label: 'Concluído' },
  { key: 'emailsent', label: 'Contato\nRealizado' },
];

const getStatusTexts = (status) => {
  switch (status) {
    case 'sending':
      return {
        title: 'Enviando formulário...',
        subtitle: 'Estamos processando seus dados.',
      };
    case 'saved':
      return {
        title: 'Dados recebidos!',
        subtitle: 'Agora estamos finalizando o envio dos e-mails.',
      };
    case 'emailsent':
      return {
        title: 'Tudo certo!',
        subtitle: 'Seu contato foi enviado com sucesso. Obrigado!',
      };
    case 'error':
      return {
        title: 'Algo deu errado 😥',
        subtitle: 'Não conseguimos enviar o formulário. Tente novamente.',
      };
    default:
      return { title: '', subtitle: '' };
  }
};

const FormStatus = forwardRef(({ status, onClose }, ref) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (status !== 'idle' && status !== 'default') {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [status]);

  useEffect(() => {
    if (visible && ref?.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [visible, ref]);

  const getColorForStep = (stepKey, index, activeIndex, hasError) => {
    if (hasError && index >= activeIndex) return '#FF4D4F';
    if (stepKey === 'sending') return '#FFD700';
    if (stepKey === 'saved') return '#4CAF50';
    if (stepKey === 'emailsent') return '#00CC88';
    return '#666';
  };

  const activeIndex = steps.findIndex((s) => s.key === status);
  const showOk = status === 'emailsent' || status === 'error';
  const hasError = status === 'error';

  const { title, subtitle } = getStatusTexts(status);

  if (!visible || activeIndex === -1) return null;

  return (
    <div style={styles.overlay} ref={ref}>
      <div style={styles.popover}>
        <h3 style={styles.title}>{title}</h3>
        <p style={styles.subtitle}>{subtitle}</p>

        <div style={styles.container}>
          {steps.map((step, index) => {
            const isActive = index <= activeIndex;
            const stepColor = getColorForStep(step.key, index, activeIndex, hasError);

            return (
              <React.Fragment key={step.key}>
                <div style={styles.wrapper}>
                  <div style={styles.circle(isActive, stepColor)} />
                  <div style={styles.label}>{step.label}</div>
                </div>
                {index < steps.length - 1 && (
                  <div style={styles.line(index < activeIndex, stepColor)} />
                )}
              </React.Fragment>
            );
          })}
        </div>

        {showOk && (
          <button onClick={onClose} style={styles.okButton}>
            OK
          </button>
        )}
      </div>
    </div>
  );
});

export default FormStatus;
